var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntergovernmental(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.00003,24.59225l-2.57281,1.53479-19.13037,11.41205v25.07111l14.61951,8.68036h0l6.93396,4.11719,8.19482-4.79919,13.65802-7.99835v-25.07092l-21.70312-12.94702Zm-.00006,23.14313l-12.72443-7.34644,15.6488-9.33514,12.77209,7.6192-15.69647,9.06238Zm-17.67383,12.53363v-16.92749l.98602-.58826,14.67322,8.47156v17.09723l-1.05536,.61804-14.60388-8.67108Zm19.68848,5.69348v-14.73761l15.65924-9.04089v14.60828l-15.65924,9.17023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntergovernmental);
export default __webpack_public_path__ + "static/media/icon_intergovernmental.31fff32293aabbb8c401deca9b016b05.svg";
export { ForwardRef as ReactComponent };